import cx from 'classnames';
import React from 'react';

import imgPhone from 'images/pro/Phone.png';
import imgTriangleTop from 'images/pro/TriangleTop.svg';

import useCurrentUser from '../../hooks/useCurrentUser';
import { subscribe_promotion_path, upgrade_subscription_path } from '../../routes';

const PRO_OFFER_CODE = 'pro-disc25';
const YEARLY_OFFER_CODE = 'yearly';
const MONTHLY_OFFER_CODE = 'monthly';
const YP_OFFER_CODE = 'yp199';

const ProHero = () => {
  const { currentUser } = useCurrentUser();
  const isCurrentUserSubscriber = currentUser?.is_subscriber;
  const isCurrentUserProSubscriber = currentUser?.is_pro_subscriber;

  return (
    <div className="px-16 xs:px-48 my-32 md:mt-72">
      <div className="flex md:max-w-1024 mx-auto relative">
        <div className="sm:max-w-458 md:max-w-524">
          <p className="text-overline font-meta-bold text-red-dark uppercase m-0">
            {isCurrentUserSubscriber && !isCurrentUserProSubscriber
              ? 'Upgrade now'
              : !isCurrentUserSubscriber && 'Subscribe'}
          </p>
          <h2 className="font-meta-serif-medium text-headline-pro text-black m-0 mt-16">
            Don{'’'}t read the news.
            <br />
            Make the news.
            <br />
            The Information Pro.
          </h2>
          <p className="text-paragraph font-meta-serif-normal text-true-black m-0 mt-16">
            The Information Pro is a new service for professionals who need non-public resources to
            excel at their jobs. You{'’'}ll have access to the resources we built for
            ourselves—because we couldn{'’'}t find them anywhere else. Don{'’'}t take a meeting
            without The Information Pro.
          </p>
          {!isCurrentUserProSubscriber && (
            <a
              href={
                isCurrentUserSubscriber
                  ? upgrade_subscription_path()
                  : subscribe_promotion_path({
                      offer: `${PRO_OFFER_CODE},${YEARLY_OFFER_CODE},${MONTHLY_OFFER_CODE},${YP_OFFER_CODE}`,
                    })
              }
              className={cx(
                'text-button font-meta-medium !text-true-white bg-red-dark uppercase',
                'xs:w-245 h-40 flex items-center justify-center rounded-r-2 mt-24 md:mt-32',
                'hover:bg-red focus:bg-red transition-colors'
              )}
            >
              {isCurrentUserSubscriber ? 'Upgrade' : 'Get Started'}
            </a>
          )}
        </div>
        <div className="tw-absolute -top-24 md:-top-40 left-150 sm:left-auto sm:-right-100 mix-blend-multiply w-full xs:w-auto">
          <img className="block object-contain object-top w-full" src={imgTriangleTop} alt="" />
        </div>
        <div className="tw-hidden sm:block tw-absolute right-0 -top-24 sm:left-600 w-275 md:w-325">
          <img className="block object-contain object-top w-full" src={imgPhone} alt="" />
        </div>
        <div className="tw-hidden sm:block w-275 shrink-0" />
      </div>
    </div>
  );
};

export default ProHero;
